import { css } from '@emotion/react';
import {
  getLegalStatementLinkColor,
  getLegalStatementTextColor,
} from './makeLegalStatementStyling';

const makeDynamicLegalStatementStyling = ({ theme }) => {
  return {
    legalStatement: css({
      marginBottom: 0,
      '& p span': {
        color: getLegalStatementTextColor({ theme }),
        visibility: 'hidden',
        fontSize: `${theme.mvf.fontSize.originalTiny}px !important`,
        [theme.breakpoints.up('tabletSmall')]: {
          fontSize: `${theme.mvf.fontSize.originalLittle}px !important`,
        },
      },
      '& p span a': {
        color: getLegalStatementLinkColor({ theme }),
      },
      maxHeight: 0,
    }),
  };
};

export default makeDynamicLegalStatementStyling;
